import * as React from 'react';
import ValidTextField from '../../common/ValidTextField';
import useGlynt from '../../hooks/useGlynt';

export interface ValidTextFieldEBProps {
  setLabel: (label: string) => void;
  disabled: boolean;
  labels: string[];
  placeholder?: string;
  defaultValue?: string;
  setExtractionBatchLabel?: (value: string) => void;
  width?: string;
}

const ValidTextFieldEB: React.FC<ValidTextFieldEBProps> = ({
  setLabel,
  disabled,
  labels,
  placeholder,
  defaultValue,
  setExtractionBatchLabel,
  width = '100%',
}) => {
  const [apiDuplicated, setApiDuplicated] = React.useState(false);
  const glynt = useGlynt();
  // The backend `label` filter on extraction-batches is a substring match, and
  // the API check fires on every keystroke with no cancellation. Without these
  // refs an in-flight response for an early prefix ("Spr") can resolve AFTER
  // the final value's response and falsely mark the name as duplicated. Track
  // the latest typed value and only apply a response that (a) was issued for
  // the still-current value AND (b) returns a row whose label EXACTLY matches.
  const latestValueRef = React.useRef('');
  const checkApiDuplicated = (value: string) => {
    setLabel(value);

    if (setExtractionBatchLabel) {
      setExtractionBatchLabel(value);
    }

    latestValueRef.current = value;

    if (value.length > 0) {
      void (async () => {
        try {
          const extractions = await (
            await glynt
          ).extractionBatch.list({
            label: value,
          });
          if (latestValueRef.current !== value) return;
          const exactMatch = (extractions.results || []).some(
            (eb: { label: string }) => eb.label.toLowerCase() === value.toLowerCase()
          );
          if (exactMatch) {
            setApiDuplicated(true);
            setLabel('');
          } else {
            setApiDuplicated(false);
          }
        } catch {
          if (latestValueRef.current === value) {
            setApiDuplicated(false);
          }
        }
      })();
    } else {
      setApiDuplicated(false);
    }
  };
  return (
    <ValidTextField
      style={{ width }}
      placeholder={placeholder}
      disabled={disabled}
      initValue={defaultValue || ''}
      names={labels}
      apiDuplicated={apiDuplicated}
      setApiDuplicated={setApiDuplicated}
      checkApiDuplicated={checkApiDuplicated}
      setSubmitDisabled={() => false}
    />
  );
};

export default ValidTextFieldEB;
